import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Pagereview from "../../components/pageReview/Pagereview";
import HeroMain from "../../components/innerPageHero/HeroMain";
import FileDownloadRow from "../../components/fileDownloadRow/FileDownloadRow";
import fileTypeIcon from "../../assets/icons/File_Type.svg";
import downloadIcon from "../../assets/icons/file_download.svg";
import {
  getRegulatoryDocs,
  getRegulatoryDocsCategory,
  getAllRegulatoryDocuments,
} from "../../utils/apiCalls";
import { FormContext } from "../CMSRenderer/CMSRenderer";

const normalizePath = (path = "") => {
  if (path.startsWith("http")) {
    return path;
  }
  return path && !path.startsWith("/") ? `/${path}` : path;
};

const HealthRegulatoryDocuments = ({ config }) => {
  const targetRef = useRef(null);

  const [activeTab, setActiveTab] = useState(0);
  const [isExpand, setIsExpand] = useState(false);
  const { currentLang } = useContext(FormContext);
  const [isLoading, setIsLoading] = useState(false);
  const [catList, setCatList] = useState([]);

  const [documents, setDocuments] = useState({
    category: [],
    children: [],
    docs: [],
  });

  const accordionRefs = useRef([]);
  const tabsRef = useRef(null);

  useEffect(() => {
    const currentTabs = tabsRef.current;
    if (currentTabs) {
      const handler = (event) => {
        setActiveTab(event.detail);
        // window.scrollTo({
        //   top: 0,
        //   behavior: "smooth",
        // });
        targetRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      };
      currentTabs.addEventListener("tabClick", handler);
      return () => currentTabs.removeEventListener("tabClick", handler);
    }
  }, []);

  useEffect(() => {
    const category = documents.category[activeTab];
    if (!category?.dguid) return;
    setIsExpand(false);
    getRegulatoryDocs({
      cateID: category.dguid,
    }).then((res1) => {
      if (res1?.data) {
        const categoryData = res1.data;
        const children =
          categoryData.children?.filter(
            (child) => child.parentId === category.dguid,
          ) || [];

        setDocuments((prev) => ({
          ...prev,
          children: children,
          docs: [],
        }));

        if (children.length > 0) {
          getAllRegulatoryDocuments({}).then((docResponse) => {
            if (docResponse?.data) {
              const allDocuments = docResponse.data;

              const docsWithCategory = children.map((child) => {
                const matchingDocuments = allDocuments.filter(
                  (doc) => doc.categoryId === child.dguid,
                );

                return {
                  ...child,
                  documents: matchingDocuments,
                };
              });

              setDocuments((prev) => ({
                ...prev,
                docs: docsWithCategory,
              }));
            }
          });
        }
      }
    });
  }, [activeTab, documents.category]);

  useEffect(() => {
    if (documents.docs.length === 0) return;

    const firstAccordion = accordionRefs.current[0];

    if (firstAccordion && typeof firstAccordion.openAccordion === "function") {
      firstAccordion.openAccordion();
    }
  }, [documents.docs]);

  const expandAll = () => {
    accordionRefs.current.forEach((ref) => {
      if (ref && typeof ref.openAccordion === "function") {
        if (isExpand === false) {
          ref.openAccordion();
          setIsExpand(true);
        } else {
          ref.closeAccordion();
          setIsExpand(false);
        }
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getRegulatoryDocsCategory({
      page: 1,
      pageSize: 10,
    }).then((res) => {
      console.log(res, "category");
      const parentCategories =
        res?.data?.filter((category) => category.parentId === null) || [];
      setDocuments((prev) => ({
        ...prev,
        category: parentCategories,
      }));

      setActiveTab(0);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <HeroMain src="06_Policies, Regulations and Circulars - Health Regulatory Documents .jpg" />
      <h2 className="mb-4 Medium text-primary" ref={targetRef}>
        {currentLang === "en"
          ? config.title
          : config.title_ar
            ? config.title_ar
            : config.title}
      </h2>
      <h5
        className="md:!my-4 my-2 text-onSurfaceVariant body"
        dangerouslySetInnerHTML={{
          __html:
            currentLang === "en"
              ? config.body
              : config.body_ar
                ? config.body_ar
                : config.body,
        }}
      />

      <div className="lg:flex gap-6">
        <div className="lg:w-1/5">
          <div className="lg:overflow-y-none overflow-y-auto lg:max-h-none max-h-[250px]">
            <dda-tabs
              ref={tabsRef}
              type="text"
              hover_style="dda-tab-underline-filled"
              custom_class=""
              component_mode=""
              button_ids='["tab-btn-1","tab-btn-2","tab-btn-3"]'
              aria_label="tabs"
              tab_texts={JSON.stringify(
                documents?.category?.map((i) =>
                  currentLang === "en"
                    ? i?.titleEn
                    : i?.titleAr
                      ? i?.titleAr
                      : i?.titleEn,
                ),
              )}
              tab_type="dda-vertical-tab"
              button_name="button"
              ontabclick="index =&gt; alert(`Tab ${index + 1} clicked!`)"
            ></dda-tabs>
            <a
              class="dda-tab-item mr-tooltip"
              href={
                currentLang === "en"
                  ? config.circular_link
                  : config.circular_link_ar
                    ? config.circular_link_ar
                    : config.circular_link
              }
            >
              <span class="mr-tooltip">
                {currentLang === "en"
                  ? config.circular_text
                  : config.circular_text_ar
                    ? config.circular_text_ar
                    : config.circular_text}
              </span>
            </a>
          </div>
        </div>
        <div className="lg:w-4/5">
          {/* <div className="flex items-end gap-3 mb-4">
            <div className="flex-1">
              <dda-search-input
                placeholder={
                  currentLang === "en"
                    ? config.search_input_placeholder
                    : config.search_input_placeholder_ar
                    ? config.search_input_placeholder_ar
                    : config.search_input_placeholder
                }
                label={
                  currentLang === "en"
                    ? config.search_input_label
                    : config.search_input_label_ar
                    ? config.search_input_label_ar
                    : config.search_input_label
                }
                size="default"
                helper_text=""
                error_message=""
                validation_id=""
                show_button="true"
                has_error="false"
                custom_class=""
                component_mode=""
                button_id="button"
                input_id="Search"
                aria_label="search-input"
                button_aria_label="clear-search"
                onchange=""
                search_input_name="search-input"
                close_button_name="close-button"
                search_button_name="search-button"
                button_text={
                  currentLang === "en"
                    ? config.search_button_text
                    : config.search_button_text_ar
                    ? config.search_button_text_ar
                    : config.search_button_text
                }
              ></dda-search-input>
            </div>
            <dda-button
              button_color="default-tertiary"
              icon_button_shape="default"
              start_icon="filter_alt"
              custom_class="h-[55px] w-[55px]"
              component_mode=""
              button_id="button"
              aria_label="button"
              onclick="console.log('clicked')"
              button_name="button"
            ></dda-button>
            <dda-button
              button_color="default-tertiary"
              start_icon=""
              button_text={
                currentLang === "en"
                  ? isExpand
                    ? config.collpase_section_text
                    : config.expand_section_text
                  : isExpand
                  ? config.collpase_section_text_ar
                  : config.expand_section_text_ar
                  ? isExpand
                    ? config.collpase_section_text_ar
                    : config.expand_section_text_ar
                  : isExpand
                  ? config.collpase_section_text
                  : config.expand_section_text
              }
              end_icon=""
              custom_class="h-[55px] w-full"
              component_mode=""
              button_id="button"
              aria_label="button"
              onclick={expandAll}
              button_name="button"
            ></dda-button>
          </div> */}

          {!!config.fixedlink_catid &&
            !!documents?.category?.[activeTab]?.dguid &&
            documents.category[activeTab].dguid == config.fixedlink_catid && (
              <a
                href={
                  currentLang === "en"
                    ? config.fixedlink_link_en
                    : config.fixedlink_link_ar
                }
              >
                <div className="accordion-container bg-border mb-4">
                  <div className="accordion-header" id="">
                    <div className="header-content">
                      <span className="header-text">
                        {currentLang === "en"
                          ? config.fixedlink_text_en
                          : config.fixedlink_text_ar}
                        <i className="body material-flat-icon material-icons material-symbols-outlined"></i>
                      </span>
                    </div>
                    <i className="material-icons arrow-icon" aria-hidden="true">
                      chevron_right
                    </i>
                  </div>
                </div>
              </a>
            )}

          {documents?.docs?.length > 0 ? (
            documents.docs.map((items, index) => (
              <dda-accordion
                key={items.dguid}
                ref={(el) => (accordionRefs.current[index] = el)}
                design="bg-border"
                accordion_icon_class="material-icons  material-symbols-outlined"
                accordion_icon_text=""
                header_text={
                  currentLang === "en"
                    ? items?.titleEn || ""
                    : items?.titleAr || ""
                }
                sub_title=""
                body_description=""
                link_button_text=""
                custom_class="mb-4"
                component_mode=""
              >
                {items?.documents?.length > 0 ? (
                  (() => {
                    const filteredDocs = items.documents.filter((docs) => {
                      if (currentLang === "en") {
                        return docs?.textEn && docs?.file;
                      } else {
                        return docs?.textAr && docs?.fileAr;
                      }
                    });

                    return filteredDocs.length > 0 ? (
                      filteredDocs.map((docs, docsIndex) => (
                        <React.Fragment key={docs.dguid || docsIndex}>
                          <a
                            href={
                              currentLang === "en"
                                ? normalizePath(docs?.file)
                                : normalizePath(docs?.fileAr)
                            }
                            target="_blank"
                          >
                            <FileDownloadRow
                              fileIcon={fileTypeIcon}
                              fileName={
                                currentLang === "en"
                                  ? docs?.textEn
                                  : docs?.textAr
                              }
                              downloadIcon={downloadIcon}
                              // onDownload={() => {
                              //   window.open(`${currentLang === "en" ? docs?.file || "" : docs?.fileAr || ""}`);
                              // }}
                            />
                          </a>
                          {filteredDocs.length === docsIndex + 1 ? (
                            ""
                          ) : (
                            <hr className="my-3" />
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <div className="text-center py-4 text-gray-500">
                        {currentLang === "en"
                          ? config.noDocumentsSectionTextEn
                          : config.noDocumentsSectionTextAr}
                      </div>
                    );
                  })()
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    {currentLang === "en"
                      ? config.noDocumentsSectionTextEn
                      : config.noDocumentsSectionTextAr}
                  </div>
                )}
                {!!items.FootNoteEn && (
                  <div className="py-2">
                    <p>
                      <b>{currentLang === "en" ? "Note" : "ملاحظة"}:</b>
                    </p>
                    <p>
                      {currentLang === "en"
                        ? items.FootNoteEn
                        : items.FootNoteAr}
                    </p>
                  </div>
                )}
              </dda-accordion>
            ))
          ) : (
            <div className="text-center py-8 text-gray-500">
              {currentLang === "en"
                ? config.noDocumentsCategoryTextEn
                : config.noDocumentsCategoryTextAr}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HealthRegulatoryDocuments;
